import { Badge, type SxProps } from "@mui/material";
import { Text } from "@src/lib/ui-react";

interface CountDisplayBadgeProps {
  customSx?: SxProps;
  count: number;
  isLoading: boolean;
  hasNextPage: boolean;
}

export function CountDisplayBadge(props: CountDisplayBadgeProps) {
  const { customSx, isLoading, count, hasNextPage } = props;
  const shouldShowCount = count > 0;

  if (shouldShowCount && !isLoading) {
    return (
      <Badge
        color="error"
        badgeContent={
          <Text variant="caption" color="white">
            {count}
            {hasNextPage && "+"}
          </Text>
        }
        variant="standard"
        // oxlint-disable-next-line typescript/no-misused-spread
        sx={{ ...customSx }}
      />
    );
  }

  return null;
}
